import { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Plus, X } from "lucide-react";
import "./transformacije.css";
import "../../page-layout.css";

import img1 from "../../components/images/transformacije/1.jpg";
import img2 from "../../components/images/transformacije/2.jpg";
import img3 from "../../components/images/transformacije/3.jpg";
import img4 from "../../components/images/transformacije/4.jpg";
import img5 from "../../components/images/transformacije/5.jpg";
import img6 from "../../components/images/transformacije/6.jpg";
import img7 from "../../components/images/transformacije/7.jpg";
import img8 from "../../components/images/transformacije/8.jpg";
import img9 from "../../components/images/transformacije/9.jpg";
import img10 from "../../components/images/transformacije/10.jpg";
import img11 from "../../components/images/transformacije/11.jpg";
import img12 from "../../components/images/transformacije/12.jpg";
import img13 from "../../components/images/transformacije/13.jpg";
import img14 from "../../components/images/transformacije/14.jpg";
import img15 from "../../components/images/transformacije/15.jpg";
import img16 from "../../components/images/transformacije/16.jpg";
import img17 from "../../components/images/transformacije/17.jpg";
import img18 from "../../components/images/transformacije/18.jpg";
import img19 from "../../components/images/transformacije/19.jpg";
import img20 from "../../components/images/transformacije/20.jpg";
import img21 from "../../components/images/transformacije/21.jpg";
import img22 from "../../components/images/transformacije/22.jpg";
import img23 from "../../components/images/transformacije/23.jpg";

const IMAGES = [
  img1, img2, img3, img4, img5, img6, img7, img8,
  img9, img10, img11, img12, img13, img14, img15,
  img16, img17, img18, img19, img20, img21, img22, img23,
];

export default function Transformacije() {
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleClose = () => setSelectedIndex(null);
  const handlePrev = () =>
    setSelectedIndex((p) => (p === 0 ? IMAGES.length - 1 : p - 1));
  const handleNext = () =>
    setSelectedIndex((p) => (p === IMAGES.length - 1 ? 0 : p + 1));

  useEffect(() => {
    const onKey = (e) => {
      if (selectedIndex === null) return;
      if (e.key === "ArrowLeft") handlePrev();
      else if (e.key === "ArrowRight") handleNext();
      else if (e.key === "Escape") handleClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [selectedIndex]);

  return (
    <div className="page-wrap">
      <div className="page-hero">
        <div className="page-hero-inner">
          <div className="page-hero-eyebrow">Rezultati</div>
          <h1 className="page-hero-title">TRANSFORMACIJE</h1>
          <p className="page-hero-desc">
            Pogledaj stvarne rezultate klijenata koji su poverili svoja tela i
            ciljeve Mihailu. Svaka slika — jedna priča o posvećenosti.
          </p>
        </div>
      </div>

      <div className="tf-body">
        <div className="tf-body-inner">
          <div className="tf-grid">
            {IMAGES.map((img, index) => (
              <div
                key={index}
                className="tf-card"
                onClick={() => setSelectedIndex(index)}
                tabIndex={0}
                role="button"
                onKeyDown={(e) => e.key === "Enter" && setSelectedIndex(index)}
                aria-label={`Otvori sliku ${index + 1}`}
              >
                <img src={img} alt={`Transformacija ${index + 1}`} />
                <div className="tf-card-overlay">
                  <Plus size={46} strokeWidth={1.8} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedIndex !== null && (
        <div className="tf-modal" onClick={handleClose}>
          <div
            className="tf-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="tf-modal-close" onClick={handleClose}>
              <X size={34} strokeWidth={2.2} />
            </button>
            <button className="tf-modal-nav tf-prev" onClick={handlePrev}>
              <ChevronLeft size={28} strokeWidth={2.2} />
            </button>
            <img
              src={IMAGES[selectedIndex]}
              alt={`Transformacija ${selectedIndex + 1}`}
            />
            <button className="tf-modal-nav tf-next" onClick={handleNext}>
              <ChevronRight size={28} strokeWidth={2.2} />
            </button>
            <div className="tf-modal-counter">
              {selectedIndex + 1} / {IMAGES.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
